<template>
    <div>
        <page-title heading="Data Stok Obat & BHP" :breadcrumb="[
          {
            label: 'Manajamen Stok',
            link: '/stok',
          },
          {
            label: 'Data Stok',
            active: true,
          },
        ]" class="layout gantung ninja-shadow" />
        <div class="container-fluid ">
            <div class="ml-4 mb-3" style="margin-top: -90px;">
                <b-button variant="outline-dark" class="align-self-end font-weight-bold mr-2" :to="{
                    name: 'klinik-stok-obat'
                }" style="border-radius:0.65rem">
                    Obat
                </b-button>
                <b-button variant="outline-primary" class="align-self-end font-weight-bold" :to="{
                    name: 'klinik-stok-bhp'
                }" style="border-radius:0.65rem">
                    Bahan Habis Pakai
                </b-button>
            </div>
            <div id="list-stok-bhp" class="card card-box ninja-shadow">
                <div class="card-body __zoom_display">
                    <b-col md="12" style="padding-left: 40px;padding-right: 40px;">
                        <DataTableWrapper :perPage="perPage" :fromPage="fromPage" :toPage="toPage"
                            :totalEntries="totalEntries" :currentPage="currentPage" :callbackFunc="fetchListObat"
                            :customEntryOptions="{f: [5]}" @valueChanged="handleValueChanged">
                            <template v-slot:right-header>
                                <b-button v-if="hasFeatures('download')" variant="danger"
                                    class="text-uppercase align-self-end mr-3" @click="downloadObat">
                                    <font-awesome-icon icon="download" />
                                    Download data
                                </b-button>
                                <b-button v-if="hasFeatures('upload')" variant="success"
                                    class="text-uppercase align-self-end mr-3" @click="goUpload">
                                    <font-awesome-icon icon="upload" />
                                    upload data
                                </b-button>
                                <b-button v-if="hasFeatures('tambah_bhp')" variant="primary"
                                    class="text-uppercase align-self-end" :to="{
                                      name: 'klinik-stok-bhp-tambah',
                                      query: {
                                            selectedId: JSON.stringify(selectedId)
                                        }
                                    }">tambah stok bhp</b-button>
                            </template>
                            <b-table id="obat-stok-dt" :items="obatList" :fields="fieldList" :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc" :no-local-sorting="true">
                                <!-- HEADER SLOT -->
                                <template v-slot:head()="data">
                                    {{ data.label }}
                                    <b-input size="sm" class="mt-2 w-95" v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)" />
                                </template>

                                <template v-slot:head(id)="data">
                                    <div class="bg-cst-box">
                                        <b-form-checkbox class="cst-cbox" v-model="selectedAll"
                                            @input="isSelectedAll = true"></b-form-checkbox>
                                    </div>
                                </template>

                                <template v-slot:head(stok)="data">
                                    {{ data.label }}
                                    <b-input size="sm" :type="'number'" class="mt-2 w-95"
                                        @input="searchValueChanged($event, data.field.key)"></b-input>

                                </template>

                                <template v-slot:head(action)="data" class="align-top">
                                    <div style="height: 60px;">
                                        <span class="mt-2">{{ data.label }}</span>
                                    </div>
                                </template>

                                <template v-slot:head(last_modified)="data">
                                    <div style="height: 60px;">
                                        <span class="mt-2">{{ data.label }}</span>
                                    </div>
                                </template>

                                <!-- CELL SLOT -->
                                <template v-slot:cell(id)="data">
                                    <b-form-checkbox v-model="selectedId" :value="data.item.id"
                                        @input="isSelectedAll = false"></b-form-checkbox>
                                </template>
                                <template v-slot:cell(stok)="data">
                                    <span>{{ data.item.stok }}</span>
                                </template>
                                <template v-slot:cell(satuan)="data">
                                    <span>{{ data.item.satuan_name || '-' }}</span>
                                </template>
                                <template v-slot:cell(action)="data">
                                    <b-button variant="primary" v-tooltip="{
                                        content: `Detail Stok`,
                                    }" class="text-uppercase align-self-end" :to="{
                                          name: 'klinik-stok-bhp-edit',
                                          params: {
                                            id: data.item.id
                                          }
                                        }">
                                        <font-awesome-icon icon="search" />
                                    </b-button>
                                </template>
                                <template v-slot:cell(last_modified)="data">
                                    <label style="font-size:12pt;">
                                        {{ dateToLocale(data.item.updated.at) || '-' }} <br>
                                        by <b>{{ data.item.updated.by || '-' }}</b>
                                    </label>
                                </template>
                            </b-table>
                        </DataTableWrapper>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { union } from "lodash";
import debounce from "lodash/debounce";
import moment from "moment";

import {
    faCopy,
    faSearch,
    faDownload,
    faUpload
} from "@fortawesome/free-solid-svg-icons";

moment.locale('id')
export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper")
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            totalEntries: 0,
            sortBy: "",
            sortDesc: false,
            searchValue: [],

            fieldList: [
                {
                    key: "id",
                    thStyle: "width: 5%",
                    searchable: false
                },
                {
                    key: "kode_layanan",
                    label: "Kode BHP",
                    thStyle: "width: 10%",
                    searchable: true,
                    sortable: true
                },
                {
                    key: "nama_layanan",
                    label: "nama BHP",
                    thStyle: "width:35%",
                    searchable: true,
                    sortable: true
                },
                {
                    key: "stok",
                    label: "stok",
                    thStyle: "width: 10%",
                    searchable: true,
                    sortable: true
                },
                {
                    key: "satuan",
                    label: "Satuan",
                    thStyle: "width: 15%",
                    searchable: true,
                    sortable: true
                },
                {
                    key: "action",
                    label: "actions",
                    thStyle: "width: 10%",
                    searchable: false
                },
                {
                    key: "last_modified",
                    label: "Last Modified By",
                    thStyle: "width: 15%",
                    searchable: false
                }
            ],

            obatList: [],

            selectedAll: false,
            isSelectedAll: false,
            currentPageChange: false,
            selectedId: []
        };
    },
    computed: {
        ...mapGetters(["getKlinikId", "getRolesName", "klinikUser"])
    },
    created() {
    },
    watch: {
        selectedAll(val) {
            const { currentPage, perPage, selectedId, obatList } = this;

            let selectedByUser = [...obatList].splice(0, perPage).map(bhp => {
                return bhp.id;
            });

            if (!val && !this.currentPageChange && this.isSelectedAll) {
                this.selectedId = this.selectedId.filter(
                    item => selectedByUser.indexOf(item) < 0
                );
            }

            if (val && this.isSelectedAll) {
                let mergeArray = selectedId.concat(selectedByUser);
                this.selectedId =
                    this.selectedId.length > 0
                        ? union(mergeArray, selectedId)
                        : mergeArray;
            }
            this.isSelectedAll = false;
            this.currentPageChange = false;
        },
        currentPage(val) {
            this.selectedAll = false;
            this.currentPageChange = true;
            this.fetchListObat().then(() => {
                this.activePageSelectedAll();
            });
        },
        perPage() {
            this.fetchListObat();
        },
        selectedId() {
            this.activePageSelectedAll();
        },
        sortBy() {
            this.fetchListObat();
        },
        sortDesc() {
            this.fetchListObat();
        },
        searchValue: {
            handler: "fetchListObat",
            deep: true
        }
    },
    methods: {
        dateToLocale(date) {
            return moment(date).format('MMM DD, YYYY @ HH:mm');
        },
        activePageSelectedAll() {
            let activeBhp = this.obatList.map(item => item.id);
            let allBhpSelected = this.selectedId.filter(
                item => activeBhp.indexOf(item) >= 0
            );
            if (activeBhp.length == allBhpSelected.length) this.selectedAll = true;
            else this.selectedAll = false;
        },
        hasFeatures(value) {
            const features = {
                tambah_bhp: ["pic_cabang", "apoteker"],
                edit_bhp: ["pic_cabang", "apoteker"],
                delete_bhp: ["pic_cabang", "apoteker"],
                upload: ["pic_cabang", "apoteker"],
                download: ["pic_cabang", "apoteker"]
            };

            const isOwner = features[value].filter(feature => {
                return this.getRolesName.includes(feature);
            });
            return isOwner.length > 0 ? true : false;
        },
        async fetchListObat() {
            let response = await this.$axios.get(
                `klinik/bhp?klinik_id=${this.getKlinikId}&limit=${this.perPage
                }&inserted_stock=1&page=${this.currentPage}${this.determineParameter()}`
            );
            // this.determineParameter()
            // let response = await new Promise((resolve, reject) => {
            //     setTimeout(() => {
            //         resolve({
            //             status: true,
            //             data: {
            //                 data: {
            //                     data: [
            //                         {
            //                             id: 1,
            //                             kode_layanan: "OBT01",
            //                             nama_layanan: "Obat 1",
            //                             stok: 19,
            //                             updated: {
            //                                 at: "Sep 10, 2022 @ 22:10",
            //                                 by: "Anonim"
            //                             }
            //                         },
            //                         {
            //                             id: 2,
            //                             kode_layanan: "OBT02",
            //                             nama_layanan: "Obat 2",
            //                             stok: 87,
            //                             updated: {
            //                                 at: "Sep 10, 2022 @ 09:10",
            //                                 by: "Bjorka"
            //                             }
            //                         }
            //                     ]
            //                 }
            //             }
            //         })
            //     }, 3000)
            // })


            const { status, data } = response;

            if (status) {
                const {
                    data: obatList,
                    total: totalEntries,
                    to: toPage,
                    from: fromPage
                } = data.data;

                this.obatList = obatList;
                this.rows = totalEntries || 0;
                this.toPage = toPage || 0;
                this.fromPage = fromPage || 0;
                this.totalEntries = totalEntries;

                return this;
            }
        },
        showDetailBhp() { },

        // SETTING TABLE
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            const { searchValue } = this;

            const z = searchValue.filter(item => item.key !== key);

            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";

            searchValue.map(item => {
                const x = item.key;
                v += `&${x}=${item.value}`;
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }
            return v;
        },
        async downloadObat() {

            let clinicName = this.klinikUser.find(item => item.id == this.getKlinikId).name
            let payload = {
                name: clinicName,
                type: "bhp",
                klinik_id: this.getKlinikId,
                id: this.selectedId
            }

            const res = await this.$axios.post(`klinik/stock/download`, payload);
            const { status, data } = res.data;

            if (status) {
                let link = document.createElement("a");
                link.href = data.link;
                link.setAttribute("download", data.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.selectedId = [];
            } else {
                this.$swal({
                    text: "Something went wrong",
                    type: "error"
                });
            }
        },
        goUpload() {
            this.$store.commit("SET_UPLOAD_BHP", null);
            this.$router.push({
                name: "klinik-stok-bhp-upload"
            });
        }
    },
};
library.add(faCopy, faUpload, faDownload, faSearch);
</script>

<style lang="css">
.bg-cst-box {
    background: #fff;
    border: 1px solid #cdcdcd;
    width: 30px;
    margin: 15px auto;
    height: 30px;
    border-radius: 8px;
}

.cst-cbox .custom-control-input:checked~.custom-control-label::after {
    background-image: none !important;
}

.cst-cbox .custom-control-input:checked~.custom-control-label::before,
.cst-cbox .custom-control-input:checked~.custom-control-label::after {
    color: #fff;
    border-color: #cdcdcd;
    background-color: #6b6b72;
}

.cst-cbox .custom-control-label::before,
.cst-cbox .custom-control-label::after {
    border-radius: 4px;
    margin-top: 2px;
    margin-left: 3.2px;
}

.layout-gantung {
    border-radius: 0px 0px 10px 10px;
    max-height: 250px;
}

.ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
}

#list-stok-bhp .__zoom_display {
    transform: scale(0.81);
    width: 128%;
    margin-left: -14%;
    font-size: 12pt;
}

#obat-stok-dt {
    font-size: 13pt;
}

#obat-stok-dt thead th,
#obat-stok-dt tbody tr td {
    font-size: 12pt;
}
</style>